module.exports = __webpack_public_path__ + "static/media/1.e4156093.svg";